import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@bingads-webui-react/primitive';

export class CustomizedDropdown extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { dropdownIsOpen: false, shouldRender: false };
  }

  toggleDropdown = () => this.setState((state, props) => ({
    dropdownIsOpen: !state.dropdownIsOpen,
    shouldRender: state.shouldRender || !!(((props.id !== 'tools' && props.id !== 'import') || (props.forwardedRef || state.dropdownIsOpen))),
  }))

  render() {
    const {
      id,
      renderDropdownToggle,
      renderDropdownMenu,
      forwardedRef,
    } = this.props;

    const shouldRender = !!(((id !== 'tools' && id !== 'import') || (forwardedRef || this.state.dropdownIsOpen)));

    return (
      <Dropdown
        id={id}
        onToggle={this.toggleDropdown}
        open={this.state.dropdownIsOpen}
        ref={forwardedRef}
      >
        {renderDropdownToggle()}
        {(this.state.shouldRender || shouldRender) && renderDropdownMenu(this.toggleDropdown)}
        {!(this.state.shouldRender || shouldRender) && <Dropdown.Menu />}
      </Dropdown>
    );
  }
}

CustomizedDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  renderDropdownToggle: PropTypes.func.isRequired,
  renderDropdownMenu: PropTypes.func.isRequired,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

CustomizedDropdown.defaultProps = {
  forwardedRef: undefined,
};

export const CustomizedDropdownWithRef = React.forwardRef((props, ref) =>
  <CustomizedDropdown {...props} forwardedRef={ref} />);
